/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 事件模块路由
 */

const EventCombine = () => import('@/views/setting/eventCombine.vue')
const EventList = () => import('@/views/event/eventList.vue')
const EventDetail = () => import('@/views/event/eventDetail.vue')
/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/event',
    component: Layout,
    redirect: 'event/list',
    meta: {
        title: '事件追踪',
        icon: 'icon-zhuizong',
        alwaysShow: true
    },
    children: [
        {
            path: 'list',
            component: EventList,
            name: 'EventList',
            meta: {
                title: '事件列表'
            }
        },
        {
            path: 'combine',
            component: EventCombine,
            name: 'EventCombine',
            meta: {
                title: '事件合并'
            }
        },
        {
            path: ':id',
            component: EventDetail,
            name: 'EventDetail',
            meta: {
                title: '事件详情',
                hidden: true
            }
        }
    ]
}
